import React from 'react';
import LegalPageLayout from './LegalPageLayout';

const PrivacyPolicy: React.FC = () => {
  return (
    <LegalPageLayout title="Privacy Policy">
      <h3>1. Introduction</h3>
      <p>
        ProGeoData ("we," "our," or "us") respects your privacy and is committed to protecting it through our compliance with this policy. 
        This policy describes the types of information we may collect from you or that you may provide when you visit our website or use our API services.
      </p>

      <div className="bg-slate-800 border border-slate-700 p-4 rounded-lg my-6">
        <h4 className="text-white font-bold mt-0">Age Limitation (18+)</h4>
        <p className="mb-0">
          Our services are intended strictly for users who are 18 years of age or older. 
          We do not knowingly collect personal information from children under 18. 
          If you are under 18, do not use or provide any information on this Website or through any of its features.
        </p>
      </div>

      <h3>2. Information We Collect</h3>
      <p>
        We collect information solely for the purpose of providing professional business intelligence. 
        This includes public record data regarding licensed professionals (e.g., license numbers, business addresses).
        For our users, we collect account information such as name, email address, and payment information needed to facilitate the service.
      </p>

      <h3>3. GDPR Compliance</h3>
      <p>
        For users and data subjects located in the European Economic Area (EEA), we adhere to the General Data Protection Regulation (GDPR).
      </p>
      <ul>
        <li><strong>Right to Access:</strong> You have the right to request copies of your personal data.</li>
        <li><strong>Right to Rectification:</strong> You have the right to request that we correct any information you believe is inaccurate.</li>
        <li><strong>Right to Erasure:</strong> You have the right to request that we erase your personal data, under certain conditions.</li>
      </ul>
      <p>
        To exercise these rights, please contact our Data Protection Officer at privacy@progeodata.com.
      </p>

      <h3>4. Data Usage</h3>
      <p>
        We use the data we collect to:
        <ul>
          <li>Provide and maintain our Service.</li>
          <li>Notify you about changes to our Service.</li>
          <li>Allow you to participate in interactive features of our Service.</li>
          <li>Provide customer support.</li>
          <li>Monitor the usage of our Service to detect and prevent technical issues.</li>
        </ul>
      </p>

      <h3>5. Contact Us</h3>
      <p>
        If you have any questions about this Privacy Policy, please contact us at privacy@progeodata.com.
      </p>
    </LegalPageLayout>
  );
};

export default PrivacyPolicy;